module.exports = __webpack_public_path__ + "img/logo_footer.ace88bbc.jpg";